<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> عملکرد رانندگان </span>

    </div>

</div>

<div dir="rtl" class="form row gx-2 px-2 w-100 ">

    <div class="col-12 col-md-3 px-1 ">

        <label> نام دانش آموز </label>

        <input type="search" class="form-control" [(ngModel)]="searchT_student" (input)="filterStudent()" />

        <ul class="list-group" style="max-height: 200px;overflow: auto;">

            <li class="list-group-item pointer" *ngFor="let item of filteredStudents" [@fadeAnimation] (click)="onStudentSelect(item)">{{ item.strPassenger_FullName }}</li>

        </ul>

    </div>

    <div class="col-12 col-md-3 px-1 ">

        <label> نام راننده </label>

        <input type="search" class="form-control" [(ngModel)]="searchT_driver" (input)="filterDriver()" />

        <ul class="list-group" style="max-height: 200px;overflow: auto;">

            <li class="list-group-item pointer" *ngFor="let item of filteredDrivers" [@fadeAnimation]  (click)="onDriverSelect(item)">{{ item.strFullName }}</li>

        </ul>

    </div>

    <div class="col-12 col-md-2 px-1 " [formGroup]="dateFilter">

        <label> از تاریخ </label>

        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

            [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

            <input type="text" formControlName="fromDate" class="form-control  " />

        </ng-persian-datepicker>

    </div>

    <div class="col-12 col-md-2 px-1 " [formGroup]="dateFilter">

        <label> تا تاریخ </label>

        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
        
            [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

            <input type="text" formControlName="toDate" class="form-control  " />

        </ng-persian-datepicker>

    </div>

    <div class="col-12 col-md-2 mt-2 mt-md-0 d-flex align-items-end ">

        <button class="btn btn-success w-100" (click)="searchPerformance()"> جستجو </button>

    </div>

</div>

<div dir="rtl" class="border border-2 p-2 ">

    <span *ngIf="list_Students.length > 0"> تعداد <span class="text-danger fw-bold">{{list_Performance.length | faNum}}</span> مورد یافت شد </span>

</div>

<div dir="rtl" class="m-2 table-responsive " style="max-height: 82vh;">

    <table class="table table-striped">

        <thead class="position-sticky top-0 bg-white">

            <tr class="col-12 text-center">

                <th> # </th>
                <th> مشخصات </th>
                <th> کد سرویس </th>
                <th> تاریخ </th>
                <th> وضعیت سرویس </th>
                <th> مدرسه </th>
                <th> دانش آموز </th>
                <th> راننده </th>
                <th> موبایل راننده </th>
                <th> ساعت شروع </th>
                <th> ساعت پایان </th>
            </tr>

        </thead>

        <tbody>

            <tr class="col-12 text-center" *ngFor="let item of list_Performance;let i = index">

                <td>{{ i+1 | faNum }}</td>

                <td>
                    <i class="fa fa-id-card-o fa-lg btn btn-primary" title="مشخضات" aria-hidden="true" (click)="detailModal(item)"></i>
                </td>

                <td>{{item.iOfficialTrip | faNum }}</td>
                <td>{{item.strTripDate | faNum}}</td>
                <td>{{item.strTripStatus}}</td>
                <td>{{item.strMobileDomain_strComment}}</td>
                <td>{{item.strPassenger_FullName | faNum}}</td>
                <td>{{item.strMobileDomain_strComment}}</td>
                <td>{{item.strMobile_Driver | faNum}}</td>
                <td>{{(item.strTrimpStartTime) | faNum}}</td>
                <td>{{item.strTrimpFinishTime | faNum}}</td>

            </tr>

        </tbody>

    </table>

</div>

<div class="modal fade" id="detailModal" tabindex="-1" aria-labelledby="" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h3 class="modal-title"> مشخصات </h3>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <main dir="rtl" class="p-2">

                <span class="box-title"> مشخصات دانش آموز </span>

                <div class="border border-2 rounded form row gx-2">

                    <div class="col-4">

                        <label> نام و نام خانوادگی </label>

                        <input [ngModel]="detailService.strPassenger_FullName" name="strPassenger_FullName" type="text" class="x form-control">

                    </div>

                    <div class="col-4">

                        <label> مدرسه </label>

                        <input [ngModel]="detailService.strMobileDomain_strComment" name="strMobileDomain_strComment" type="text" class="x form-control">

                    </div>

                    <div class="col-4">

                        <label> شماره موبایل </label>

                        <input dir="ltr" [ngModel]="(detailService.strMobile  | faNum)" name="strMobile" type="text"  class="x form-control">

                    </div>

                    <div class="col-12 position-relative">

                        <label for="strAddress">آدرس</label>

                        <input [ngModel]="detailService.strAddress" id="strAddress" name="strAddress"  class="x form-control col-md-10 py-2">

                        <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button" (click)="showOnMap(detailService.fOrigiLat,detailService.fOriginLon,'مبدا')">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                        </button>

                    </div>

                </div>

                <span class="box-title"> مشخصات راننده </span>

                <div class="border border-2 rounded form row gx-2">

                    <div class="col-12 col-md-3">

                        <label> نام و نام خانوادگی </label>

                        <input [ngModel]="detailService.strFullName" name="strFullName" type="text" class="x form-control">

                    </div>

                    <div class="col-12 col-md-3">

                        <label> شماره موبایل </label>

                        <input dir="ltr" [ngModel]="( detailService.strMobile_Driver | faNum )" name="strMobile_Driver" type="text" class="x form-control">

                    </div>

                    <div class="col-12 col-md-3">

                        <label> نوع خودرو </label>

                        <input [ngModel]="detailService.strMobileType_strComment " name="strMobileType_strComment" type="text" class="x form-control">

                    </div>

                    <div class="col-12 col-md-3  ">

                        <!-- <div class="col-3 d-flex justify-content-center align-items-center pt-3 "> -->
                        
                        <label> پلاک </label>

                        <input dir="ltr" [ngModel]="(detailService.strVehicleNo | faNum )" name="strVehicleNo" type="text" class="x fw-bold text-center form-control">

                        <!-- <div class="containerpl">

                            <div class="license-plate">

                                <div class="blue-column">

                                    <div class="flag">

                                        <div></div>

                                        <div></div>
                                        
                                        <div></div>
                                        
                                    </div>

                                    <div class="text">

                                        <div>I.R.</div>

                                        <div>IRAN</div>

                                    </div>

                                </div>

                                <span> ۹۶ </span>

                                <span class="alphabet-column"> ط </span>

                                <span> ۴۲۸ </span>

                                <div class="iran-column"><span>ایــران</span><strong>۳۰ </strong></div>

                            </div>

                        </div> -->

                    </div>

                    <div class="rtl row gx-2 text-center w-100 mt-2 border border-2 p-2" *ngIf="lstDrivers_Student.length > 0 ">

                        <span class="bg-warning rounded col-12 py-2 rounded fw-bold" > لیست دانش آموزان {{detailService.strPassenger_FullName | faNum }} </span>
    
                        <div class="table-responsive" style="max-height: 30vh;">
    
                            <table class="table table-striped" id="Export_Excel">
    
                                <thead class="position-sticky top-0 bg-white">
    
                                    <tr class="col-12 text-center">
    
                                        <th> # </th>
    
                                        <th> تصویر </th>
    
                                        <th> جنسیت </th>
    
                                        <th> نام و نام خانوادگی </th>
    
                                        <th> مدرسه </th>
    
                                        <th> فاصله تا مدرسه </th>
    
                                    </tr>
    
                                </thead>
    
                                <tbody>
    
                                    <tr class="col-12 text-center" *ngFor="let item of lstDrivers_Student;let i = index">
    
                                        <td> {{i+1 | faNum}} </td>
    
                                        <td><img class="rounded-circle" width="50" height="50" src="{{item.strAvatar.trim() != '' ? 'data:image/jpeg;base64,' + item.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}" [alt]="item.strName + item.strFamily"> </td>
    
                                        <td>{{item.strSex_strSexComment}}</td>
    
                                        <td>{{item.strPassenger_FullName | faNum}}</td>
    
                                        <td>{{item.strMobileDomain_strComment}}</td>
    
                                        <td>{{ ( item.fDistance | faNum ) + ' کیلومتر '}}</td>
    
                                    </tr>
    
                                </tbody>
    
                            </table>
    
                        </div>
    
                    </div>
    
                    <div class="rtl mt-2 border border-2 p-2 text-center bg-danger text-white" *ngIf="lstDrivers_Student.length == 0 ">
    
                        <span> هنوز دانش آموزی به این راننده اختصاص داده نشده است </span>
    
                    </div>

                </div>

                <span class="box-title"> مشخصات سرویس </span>

                <div class="border border-2 rounded form row gx-2">

                    <div class="col-12 col-md-6">

                        <button class="mx-2 w-100 btn btn-success rounded" type="button" (click)="showOnMap(detailService.fsLat,detailService.fsLon,'مبدا')">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                            <span> مبدا </span>

                        </button>

                    </div>

                    <div class="col-12 col-md-6">

                        <button class="mx-2 w-100 btn btn-danger rounded" type="button" (click)="showOnMap(detailService.fDLat,detailService.fDLon,'مقصد')">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                            <span> مقصد </span>

                        </button>

                    </div>

                    <div class="col-12 col-md-6 position-relative">

                        <label> زمان اعلام آمادگی </label>

                        <input [ngModel]="(detailService.strTripConfirmationTime | faNum )" name="strTripConfirmationTime" class="x form-control text-center col-md-10 py-2">

                        <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button" (click)="showOnMap(detailService.fConfirmationLat,detailService.fConfirmationLog,'اعلام آمادگی')">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                        </button>

                    </div>

                    <div class="col-12 col-md-6 position-relative">

                        <label> زمان رسیدن راننده </label>

                        <input [ngModel]="(detailService.strRedy4TrimpTime | faNum )" name="strRedy4TrimpTime" class="x form-control text-center col-md-10 py-2">

                        <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button" (click)="showOnMap(detailService.fReady4TripLat,detailService.fReady4TripLog,'رسیدن راننده')">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                        </button>

                    </div>

                    <div class="col-12 col-md-6">

                        <label> زمان سوار شدن دانش آموز </label>

                        <input  type="text" [ngModel]="(detailService.strTrimpStartTime | faNum )" name="strTrimpStartTime" class="x form-control text-center">

                    </div>

                    <div class="col-12 col-md-6 position-relative">

                        <label> زمان رسیدن به مقصد </label>

                        <input id="strAddress" [ngModel]="(detailService.strTrimpFinishTime | faNum )" name="strTrimpFinishTime" class="x form-control text-center col-md-10 py-2">

                        <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button" (click)="showOnMap(detailService.fFinishTripLat,detailService.fFinishTripLog,'رسیدن به مقصد')">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                        </button>

                    </div>

                    <div class="col-12 col-md-4">

                        <label> مدت سرویس </label>

                        <input  type="text" [ngModel]="(detailService.iTripTim + ' دقیقه ' | faNum )" name="iTripTim" class="x form-control text-center">

                    </div>

                    <div class="col-12 col-md-4">

                        <label> پیمایش سرویس </label>

                        <input  type="text" [ngModel]="(detailService.fTripKm + ' کیلومتر ' | faNum )" name="fTripKm" class="x form-control text-center">

                    </div>

                    <div class="col-12 col-md-4">

                        <label> مدت انتظار جهت سوار شدن  </label>

                        <input  type="text" [ngModel]="(detailService.strWaitingTime | faNum )" name="strWaitingTime" class="x form-control text-center">

                    </div>

                </div>


                <div class="pt-2">

                    <button class="btn btn-primary w-100" (click)="showPath(detailService)"> مسیر حرکت </button>

                </div>

            </main>


        </div>

    </div>

</div>

<div class="modal fade" id="Location" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h6 class="modal-title"> {{detailService?.mapTitle}} </h6>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map" class="position-sticky w-100 " style="height: 500px;">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>

    </div>

</div>

<ng-container *ngIf="isLoading" class="">

    <div class="school_loading">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>